export enum SubscriptionGroup {
    SUPPLIER = 'SUPPLIER',
    CHAMPION = 'CHAMPION',
    CAPITAL_PROVIDER = 'CAPITAL_PROVIDER',
    CAPACITY_BUILDER = 'CAPACITY_BUILDER',
}